import BaseService from "./base.service";

class SupportService extends BaseService {
  getSupportWhatsappLink() {
    try {
      return this.request().get("support/whatsapp/link");
    } catch (e) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      return this.errorWrapper(error, message);
    }
  }
}

export default new SupportService();
